document.addEventListener("DOMContentLoaded", function () {
    // Check if the current page is a product page
    if (window.location.pathname.includes('/products/')) {
        const variantId = new URLSearchParams(window.location.search).get('variant');

        // Add class to hide ISBN if variant ID matches
        if (variantId === '41623150198857') {
            const isbnElement = document.querySelector('.product-isbn');
            if (isbnElement) {
                isbnElement.classList.add('hide-isbn');
            }
        }
    }
});
